"use client";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "@/store";
import { installAuthInterceptor } from "@/lib/authInterceptor";

// Install the global 401 / session-expiry interceptor once, at client bundle
// load — before any page effect fires its first authenticated request.
installAuthInterceptor();

export default function ReduxProvider({ children }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  );
}
